<template lang="pug">
div#main
  card-credenciado(
    :cardTitle="isEdicao ? `Edição de credenciado ${tipoCadastro.toLowerCase()}` : `Cadastro de credenciado ${tipoCadastro.toLowerCase()}`"
    showBtnAction=false
  )
    template(slot="body")
      validation-observer(ref='observer', tag='form', v-slot="{ handleSubmit }")
        form(@submit.prevent="onSubmit")
          divider.margin-bottom-20(label="Dados pessoais")
          el-row.margin-bottom-20(type="flex", :gutter="40")
            el-col(:lg="12")
              validation-provider(
                ref="cpf",
                :rules="{required: true, cpf: true}",
                v-slot="{ errors }",
                name="cpf"
              )
                Label(label="CPF:", :required="true")
                el-input.input(
                  v-model="credenciado.pessoa.pessoaFisica.cpf",
                  v-mask="['###.###.###-##']"
                )
                span.error {{ errors[0] }}
            el-col(:lg="12")
              validation-provider(
                ref="nome",
                :rules="{required: true}",
                v-slot="{ errors }",
                name="nome"
              )
                Label(label="Nome:", :required="true")
                el-input.input(
                  v-model="credenciado.pessoa.pessoaFisica.nome",
                )
                span.error {{ errors[0] }}
          el-row.margin-bottom-20(type="flex", :gutter="40")
            el-col(:lg="12")
              validation-provider(
                ref="email",
                :rules="{required: true, email: true}",
                v-slot="{ errors }",
                name="email"
              )
                Label(label="E-mail:", :required="true")
                el-input.input(
                  v-model="credenciado.pessoa.email",
                )
                span.error {{ errors[0] }}
            el-col(:lg="12")
              validation-provider(
                ref="e-mail",
                rules="required|email|confirmed:email",
                v-slot="{ errors }",
                name="e-mail"
              )
                Label(label="Confirmar e-mail:", :required="true")
                el-input.input(
                  v-model="confirmarEmail",
                )
                span.error {{ errors[0] }}
          el-row.margin-bottom-20(type="flex", :gutter="40")
            el-col(:lg="12")
              validation-provider(
                ref="telefones",
                v-slot="{ errors }",
                name="telefones"
              )
                Label(label="Telefone(s):", :required="true")
                el-input.input(
                  label='Telefone',
                  v-mask="['(##) #####-####', '(##) ####-####']",
                  v-model="fone"
                  :placeholder="numeroTelefone > 2 ? 'Máximo de 3 telefones' : ''"
                  :disabled="numeroTelefone > 2"
                )
                  el-button.style(
                    slot="append",
                    icon="el-icon-plus",
                    @click="addTelefone(fone)",
                    :disabled="fone.length < 14",
                  )
                div.tag-app-input.marginTop
                  el-tag(
                    v-for="(telefone, index) in numeroTelefone",
                    :key="index",
                    closable,
                    type="info",
                    size="medium",
                    @close="removeTelefone(telefone)"
                  ) {{ telefone }}
                span.error(v-if='validaCampoTelefone') O campo é obrigatório
          divider.margin-bottom-20(label="Dados do credenciado")
          el-row.margin-bottom-20(type="flex", :gutter="40")
            el-col(:lg="12")
              validation-provider(
                ref="codigoCrea",
                :rules="{required: true}",
                v-slot="{ errors }",
                name="codigoCrea"
              )
                Label(label="Registro no conselho:", :required="true")
                el-input.input( v-model="credenciado.codigoCrea")
                span.error {{ errors[0] }}
            el-col(:lg="12" v-if="tipoCadastro === 'GEOMENSOR'")
              validation-provider(
                ref="codigoIncra",
                :rules="{required: true}",
                v-slot="{ errors }",
                name="codigoIncra"
              )
                  Label(label="Código de credenciamento no INCRA:", :required="true")
                  el-input.input(
                    v-model="credenciado.codigoIncra",
                    maxlength="4",
                    minlength="3",
                    show-word-limit,
                  )
                  span.error {{ errors[0] }}
            el-col(:lg="12" v-else)
              include commons/inputFormacaoVistoriador.pug

          el-row.margin-bottom-20(type="flex", :gutter="40" v-if="tipoCadastro === 'GEOMENSOR'")
            el-col(:lg="12")
              include commons/inputFormacaoGeomensor.pug

          divider.margin-bottom-20(label="Endereço")
          el-row.margin-bottom-20(type="flex", :gutter="40")
            el-col(:lg="12")
              validation-provider(
                ref="logradouro",
                :rules="{required: true}",
                v-slot="{ errors }",
                name="logradouro"
              )
                Label(label="Logradouro:", :required="true")
                el-input.input(
                  v-model="credenciado.pessoa.endereco.logradouro",
                  show-word-limit,
                  maxlength="100",
                )
                span.error {{ errors[0] }}

            el-col(:lg="12")
              validation-provider(
                ref="numero",
                :rules="{required: !credenciado.pessoa.endereco.numero && !credenciado.pessoa.endereco.semNumero }",
                v-slot="{ errors }",
                name="numero"
              )
                Label(label="Número:", :required="true")
                el-input.input(
                  v-model="credenciado.pessoa.endereco.numero",
                  :disabled="credenciado.pessoa.endereco.semNumero"
                  type="number"
                )
                  el-checkbox.input(
                    v-model="credenciado.pessoa.endereco.semNumero",
                    label="S/N", slot="prepend",
                    @change="onSemNumeroCheck"
                  )
                span.error {{ errors[0] }}

          el-row.margin-bottom-20(type="flex", :gutter="40")
            el-col(:lg="12")
              Label(label="Complemento:", :required="false")
              el-input.input(v-model="credenciado.pessoa.endereco.complemento")

            el-col(:lg="12")
              validation-provider(
                ref="Bairro",
                :rules="{required: true }",
                v-slot="{ errors }",
                name="Bairro"
              )
                Label(label="Bairro:", :required="true")
                el-input.input(
                  v-model="credenciado.pessoa.endereco.bairro",
                )
                span.error {{ errors[0] }}
          el-row.margin-bottom-20(type="flex", :gutter="40")
            el-col(:lg="12")
              validation-provider(
                ref="cep",
                :rules="{required: true, cep: true }",
                v-slot="{ errors }",
                name="cep"
              )
                Label(label="CEP:", :required="true")
                el-input.input(
                  v-model="credenciado.pessoa.endereco.cep",
                  v-mask="'#####-###'",
                )
                span.error {{ errors[0] }}

            el-col(:lg="12")
              validation-provider(
                ref="uf",
                :rules="{required: true }",
                v-slot="{ errors }",
                name="uf"
              )
                Label(label="UF:", :required="true")
                el-select.select.input(
                  v-model="credenciado.pessoa.endereco.uf",
                  filterable
                  @change="changeUf"
                )
                  el-option(
                    v-for="item in estados"
                    :key="item"
                    :label="item"
                    :value="item"
                  )
                span.error {{ errors[0] }}

            el-col(:lg="12")
              validation-provider(
                ref="municipio",
                :rules="{required: true }",
                v-slot="{ errors }",
                name="municipio"
              )
                Label(label="Município:", :required="true")
                el-select.select.input(
                  v-model="credenciado.pessoa.endereco.municipio.nome",
                  @change="(value) => handleChangeMunicipio(value)",
                  filterable,
                  placeholder="Selecione",
                  remote,
                  :remote-method="searchMunicipio",
                  @focus="handleMunicipios(ufSolicitacao)",
                  :disabled="!credenciado.pessoa.endereco.uf",
                )
                  el-option(
                    v-for="item in listMunicipios"
                    :key="item.id"
                    :label="item.nome"
                    :value="item.nome"
                  )
                span.error {{ errors[0] }}
          app-documentos(
            :documentos="credenciado.documentos",
            :tiposDocumentos="tiposDocumentos.tipos",
            :tiposDocumentosObrigatorios="tiposDocumentos.obrigatorios",
            :url="url",
            aba="Credenciado"
            :mensagensTipoDocumento="mensagensTipoDocumento"
            :maxSize='20'
            @addDoc="adicionaDoc"
            @removeDoc="removeDoc"
            @tipoDocumentoOnChange="changeTipoDocumentoAtivo"
            :validExtensions="extensoesDocumentoAtivo"
          )
          el-row.margin-top.footer(type="flex", justify="start")
            el-button(
              @click="cancelar"
              class="cancel"
            )
              i.fas.fa-times
              |  Cancelar
            el-button(type="primary", @click="confirmarTermos")
              i.fas.fa-check
              |  {{!isEdicao ? 'Cadastrar' : 'Salvar'}}

  modal-termos(
    :tipoCadastro="tipoCadastro"
    :modal-open="visualizarTermos"
    @close-modal="visualizarTermos = false"
    @confirmar="cadastrar"
  )

</template>

<script>
import CardCredenciado from '@/screens/credenciados/components/CardCredenciado.vue';
import { AppNotificacao, Label, Divider, InputTelefone } from 'sicarf-components';
import AppAnexo from '@/components/AppAnexo';
import AppDocumentos from '@/components/AppDocumentos';
import ModalTermos from '@/components/modalTermoCompromisso';

import { getEstados, getAllMunicipiosByUf } from '@/services/municipioService';
import { cadastroCredenciado, editarCredenciado } from '@/services/credenciadoService';
import { getEditalById } from '@/services/editalService';
import { findAllTipoDocumentosGeomensor, findAllTipoDocumentosVistoriador } from '@/services/tipoDocumentoCredenciado';
import { deleteById } from '@/services/documentoService';

import { MENSAGENS_TIPO_DOCUMENTO_CREDENCIADO } from '@/constants/constants';

export default {
  mixins: [
    AppNotificacao
  ],
  components: {
    CardCredenciado,
    Label,
    Divider,
    InputTelefone,
    AppAnexo,
    AppDocumentos,
    ModalTermos,
  },

  props: ['observer'],

  data() {
    return {
      visualizarTermos: false,
      confirmarEmail: null,
      pessoaExistente: false,
      validaCampoTelefone: false,
      loading: false,
      tiposDocumentos: {
        tipos: [],
        obrigatorios: []
      },
      mensagensTipoDocumento: MENSAGENS_TIPO_DOCUMENTO_CREDENCIADO,
      url: 'publico/documentoCredenciado/upload',
      credenciadoExistente: false,
      edital: null,
      fone: '',
      credenciado: {
        documentos: [],
        pessoa: {
          pessoaFisica: {
            cpf: null,
            nome: null,
          },
          email: null,
          telefones: [],
          endereco: {
            logradouro: null,
            numero: null,
            complemento: null,
            bairro: null,
            cep: null,
            uf: null,
            municipio: {}
          }
        },
        codigoIncra: null,
        codigoCrea: null,
        formacao: null,
      },
      ufSolicitacao: null,
      municipios: [],
      listMunicipios: [],
      estados: [],
      isEdicao: false,
      tipoDocumentoAtivo: null,
      tiposFormacoes: [
        { codigo: 'ENGENHEIRO_AGRONOMO', descricao: 'Engenheiro(a) Agrônomo' }
      ],
      tipoCadastro: '',
      idEdital: this.$route.params.idEdital,
      numeroTelefone: [],
    }
  },

  computed: {
    extensoesDocumentoAtivo () {
      return this.tipoDocumentoAtivo?.codigo === 'FOTO_PERFIL'
        ? ['png', 'jpg', 'jpeg', 'heic']
        : ['pdf', 'rar', 'zip', 'png', 'jpg', 'jpeg', 'pdf', 'doc', 'docx'];
    }
  },

  async mounted () {
    this.loading = true;

    // Preenche o form com as informações se houver uma solicitação já existente
    if (this.$route.params.solicitacao) {
      this.isEdicao = true;
      this.fillFormWithSolicitacao(this.$route.params.solicitacao);
    }

    this.edital = await getEditalById(this.idEdital);
    this.tipoCadastro = this.edital.tipoEdital ? this.edital.tipoEdital : ''
    this.estados = await getEstados();

    if (this.tipoCadastro === 'VISTORIADOR') {
      this.tiposDocumentos.tipos = await findAllTipoDocumentosVistoriador();
    } else {
      this.tiposDocumentos.tipos = await findAllTipoDocumentosGeomensor();
    }

    const indexOutros = this.tiposDocumentos.tipos.findIndex(tipo => tipo.codigo === 'OUTROS');

    this.tiposDocumentos.obrigatorios = [...this.tiposDocumentos.tipos];
    if (indexOutros !== -1) {
      this.tiposDocumentos.obrigatorios.splice(indexOutros, 1);
    }

    if (!this.edital.id && !this.$route.params.solicitacao) {
      window.location.replace(process.env.VUE_APP_SICARF_URL)
    }

    this.loading = false;
  },
  methods: {

    onSemNumeroCheck (checked) {
      if (checked) {
        this.credenciado.pessoa.endereco.numero = 0
        return
      }

      this.credenciado.pessoa.endereco.numero = null
    },

    handleChangeMunicipio(value) {
      let municipio = this.listMunicipios.find(municipio => municipio.nome === value);

      if (municipio) {
        this.credenciado.pessoa.endereco.municipio.nome = municipio.nome;
        this.credenciado.pessoa.endereco.municipio.id = municipio.id;
      } else {
        this.credenciado.pessoa.endereco.municipio.nome = value;
      }
    },

    isExternoOuCredenciado(resp) {
      if (resp.usuario && resp.usuario.perfis) {
        if (resp.usuario.perfis.length === 1 && resp.usuario.perfis[0].codigo === 'CREDENCIADOS') {
          return true
        }
        if (
          (resp.usuario.perfis.length === 1 && resp.usuario.perfis[0].codigo === 'EXTERNO') ||
          (resp.usuario.perfis.length === 1 && resp.usuario.perfis[0].codigo === 'AGENDAMENTO') ||
          (resp.usuario.perfis.length === 2 && resp.usuario.perfis[0].codigo === 'EXTERNO' && resp.usuario.perfis[1].codigo === 'AGENDAMENTO') ||
          (resp.usuario.perfis.length === 2 && resp.usuario.perfis[1].codigo === 'EXTERNO' && resp.usuario.perfis[0].codigo === 'AGENDAMENTO')) {
          return true;
        }
        return false;
      }
      return true;
    },

    async removeDoc ({row, index}) {
      this.confirmBox(this.$messages.DOCUMENTO_REMOVE_CONFIRM, this.$messages.TITULO_WARNING,
        () => {
          if (row.id && (typeof row.id) !== 'string') {
            deleteById(row.id).then(() => {
              this.credenciado.documentos.splice(index, 1)
            }).catch(() => {
              this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
                'Houve um erro ao remover o anexo.')
            })
          } else {
            this.credenciado.documentos.splice(index, 1)
          }
        },
        () => { })
    },

    adicionaDoc (documento) {
      // Verifica se for diferente do tipo 'OUTROS' não permite mais de 1 anexo por tipo de documento
      if (this.tipoDocumentoAtivo.codigo !== 'OUTROS') {
        let documentoExistente = this.credenciado.documentos.find(document => {
          return document.tipoDocumento.codigo === documento.tipoDocumento.codigo
        })

        if (!documentoExistente) {
          this.credenciado.documentos.push({caminho: documento.fileKey, nome: documento.fileName, tipoDocumento: documento.tipoDocumento})
        } else {
          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            `Já existe um anexo para o tipo ${this.tipoDocumentoAtivo.descricao}.`
          )
        }
      } else {
        this.credenciado.documentos.push({caminho: documento.fileKey, nome: documento.fileName, tipoDocumento: documento.tipoDocumento})
      }
    },

    cancelar () {
      if (this.credenciado.codigoCrea !== null || this.credenciado.codigoIncra !== null || this.credenciado.formacao !== null ||
        this.credenciado.pessoa.endereco.bairro !== null || this.credenciado.pessoa.endereco.logradouro !== null ||
        this.credenciado.pessoa.endereco.numero !== null || this.credenciado.pessoa.endereco.complemento !== null ||
        this.credenciado.pessoa.endereco.cep !== null || this.credenciado.pessoa.endereco.uf !== null ||
        this.credenciado.pessoa.endereco.municipio.length > 0 || this.credenciado.pessoa.pessoaFisica.cpf !== null ||
        this.credenciado.pessoa.pessoaFisica.nome !== null || this.credenciado.pessoa.email !== null ||
        this.credenciado.pessoa.telefones.length > 0 || this.credenciado.documentos.length > 0) {
        this.confirmBox(this.$messages.CANCELAR_CADASTRO, this.$messages.TITULO_WARNING,
          () => {
            if (this.isEdicao) {
              this.$router.push({ name: 'credenciado/solicitacoes' });
            } else {
              window.location.replace(process.env.VUE_APP_SICARF_URL)
            }
          }
        )
      } else {
        if (this.isEdicao) {
          this.$router.push({ name: 'credenciado/solicitacoes' });
        } else {
          window.location.replace(process.env.VUE_APP_SICARF_URL)
        }
      }
    },

    addTelefone (values) {
      this.fone = '';
      this.validaCampoTelefone = false;
      this.numeroTelefone.push(values);
    },

    removeTelefone (fone) {
      this.numeroTelefone.pop(fone)
      if (this.numeroTelefone.length === 0) {
        this.validaCampoTelefone = true;
      }
    },

    redirect() {
      if (!this.credenciado.id) {
        window.location.replace(process.env.VUE_APP_SICARF_URL)
      } else {
        this.$router.push({ name: 'credenciado/solicitacoes' })
      }
    },

    async cadastrar() {
      this.visualizarTermos = false
      this.loading = true;
      this.credenciado.pessoa.telefones = this.numeroTelefone.map(item => ({ numero: item }))
      this.credenciado.idEdital = this.idEdital
      let sucessCadastrar = null;
      let sucessRetificar = null;
      if (!this.credenciado.id) {
        try {
          sucessCadastrar = await cadastroCredenciado(this.credenciado)
        } catch (e) {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, e.response.data)
        }
      } else {
        sucessRetificar = await editarCredenciado(this.credenciado)
      }
      if (sucessCadastrar) {
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.CADASTRADO_SUCESSO
        )
        setTimeout(() => this.redirect(), 3000)
      }
      if (sucessRetificar) {
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.SOLICITACAO_RETIFICADA_SUCESSO,
        )
        setTimeout(() => this.redirect(), 3000)
      } else {
        this.credenciado.pessoa.telefones = this.numeroTelefone.map(item => item.numero)
        this.loading = false;
      }
    },

    async confirmarTermos () {
      this.validaCampoTelefone = this.numeroTelefone.length === 0;
      if (this.pessoaExistente) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.USUARIO_EXISTENTE,
        )
      }
      if (this.credenciadoExistente && !this.pessoaExistente) {
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          this.$messages.CREDENCIADO_CADASTRADO_EDITAL
        )
      } else if (await this.$refs.observer.validate()) {
        if (this.numeroTelefone.length === 0) {
          this.showNotificacao(
            this.$messages.TIPO_ERROR,
            this.$messages.TITULO_ERROR,
            'Nenhum telefone foi adicionado!'
          )
          this.validaCampoTelefone = true;
          return;
        }
        if (!this.pessoaExistente) {
          this.visualizarTermos = true;
        }
      } else {
        if (!this.pessoaExistente || this.numeroTelefone.length === 0) {
          this.showNotificacao(
            this.$messages.TIPO_WARNING,
            this.$messages.TITULO_WARNING,
            this.$messages.WARNING_VALIDACAO_FINALIZAR_CADASTRO
          )
        }
      }
    },

    async changeUf(value) {
      this.credenciado.pessoa.endereco.municipio = {};
      this.ufSolicitacao = value;
      this.handleMunicipios(value)
    },

    async handleMunicipios(value) {
      this.municipios = await getAllMunicipiosByUf(value);
      this.listMunicipios = this.municipios;
    },

    fillFormWithSolicitacao(solicitacao) {
      const telefones = [];

      this.credenciado.id = solicitacao.credenciado.id;
      this.credenciado.dataCadastro = solicitacao.dataCadastro;
      this.credenciado.pessoa.pessoaFisica.cpf = solicitacao.credenciado.pessoa.cpfCnpj;
      this.credenciado.pessoa.id = solicitacao.credenciado.pessoa.id;
      this.credenciado.pessoa.tipo = solicitacao.credenciado.pessoa.tipo;
      this.credenciado.pessoa.dataCadastro = solicitacao.credenciado.pessoa.dataCadastro;
      this.credenciado.pessoa.pessoaFisica.id = solicitacao.credenciado.pessoa.pessoaFisica.id;
      this.credenciado.pessoa.pessoaFisica.nome = solicitacao.credenciado.pessoa.nomeRazaoSocial;
      this.credenciado.pessoa.email = solicitacao.credenciado.pessoa.email;
      this.confirmarEmail = solicitacao.credenciado.pessoa.email;

      solicitacao.credenciado.pessoa.telefones.forEach(tel => {
        telefones.push(tel.numero)
      });

      this.credenciado.pessoa.telefones = telefones;
      this.numeroTelefone = telefones;
      this.credenciado.codigoCrea = solicitacao.credenciado.codigoCrea;
      this.credenciado.codigoIncra = solicitacao.credenciado.codigoIncra;
      this.credenciado.formacao = solicitacao.credenciado.formacao;
      this.credenciado.pessoa.endereco = solicitacao.credenciado.pessoa.endereco;
      this.municipios.push(this.credenciado.pessoa.endereco.municipio)
      this.credenciado.documentos = solicitacao.credenciado.documentos;

      this.ufSolicitacao = solicitacao.credenciado.pessoa.endereco.uf
    },

    searchMunicipio(query) {
      if (query !== '') {
        // Força o filtro da pesquisa de municípios ignorar a acentuação
        this.listMunicipios = this.municipios.filter(value => {
          let municipios = value.nome.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
          let searchQuery = query.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")

          return municipios.indexOf(searchQuery) > -1
        })
      } else {
        this.listMunicipios = this.municipios
      }
    },

    changeTipoDocumentoAtivo (tipo) {
      this.tipoDocumentoAtivo = tipo
    }
  }
}
</script>

<style lang="scss">
.card-header {
  margin-bottom: 20px;
}
.footer {
  place-content: space-between;
  margin-top: 40px;
}
.select {
  width:100%
}

.marginTop {
  margin-top: 5px;
}

.tag-app-input i{
  color: #9BA0A9 !important;
}

.tag-app-input i:hover {
  color: #F7F7F8 !important;
  background-color: #878D99 !important;
}

.el-tag {
  margin-left: 0;
  margin-right: 5px;
  margin-bottom: 5px;
  background-color: #f3f4f5;
  border-color: #dddfe2;
  color: #9ba0a9 ;
}
.style {
  color: #9ba0a9 !important;
}

.margin-bottom-20 {
  margin-bottom: 20px;
}

.margin-top-50 {
  margin-top: 50px;
}

.container-cadastro {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.el-icon-search {
  color: #009f61;
}

span::v-deep .el-input__count-inner {
  color:#009f61
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance:textfield;
}

.cancel:hover, .cancel:focus {
  background-color:#fef0f0;
  color: #f56c6c;
  border-color: #fbc4c4;
}
</style>
